// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RootStyle_adminwrapper__r--KX {
  margin: 0;
  background-color: var(--white-color);
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  padding: 0px;
  position: relative;
}

.RootStyle_sidebarBack__z4teo {
  position: absolute;
  /* top: 4%; */
  /* right: -7%; */
  z-index: 1;
  transform: translateY(-50%);
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--white-color);
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  cursor: pointer;
  color: var(--subheading);
  display: none;
  align-items: center;
  justify-content: center;
}

@media (max-width: 768px) {
  .RootStyle_sidebarBack__z4teo {
    /* right: 25px; */
    box-shadow: rgba(255, 255, 255, 0.608) 0px 7px 29px 0px;
    display: flex;
  }
  .RootStyle_rootMainContant__XgKRy.RootStyle_hidden__\\+01\\+E {
    display: none;
  }
  /* .admin-sidebar ul {
    display: none;
  } */
  .RootStyle_rotateOpen__JIljI {
    transform: rotate(180deg);
    transition: transform 0.3s ease;
    right: 2px;
    top: 10px;
  }

  .RootStyle_rotateClosed__kouXK {
    transform: rotate(0deg);
    transition: transform 0.3s ease;
    /* right: -5px; */
    right: -15px;
    top: 10px;
  }
}

@media (max-width: 368px) {
  .RootStyle_sidebarBack__z4teo {
    width: 40px;
    height: 40px;
    font-size: 22px;
    top: 1%;
    right: 15px;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    transform: translateX(16px);
    transform-origin: center;
  }
  .RootStyle_rotateOpen__JIljI {
    transform: rotate(180deg);
    transition: transform 0.3s ease;
    right: 2px;
    top: 10px;
  }

  .RootStyle_rotateClosed__kouXK {
    transform: rotate(0deg);
    transition: transform 0.3s ease;
    right: -15px;
    top: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Component/SideData/AdminRoot/RootStyle.module.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,oCAAoC;EACpC,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,2BAA2B;EAC3B,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,qDAAqD;EACrD,eAAe;EACf,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE;IACE,iBAAiB;IACjB,uDAAuD;IACvD,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;;KAEG;EACH;IACE,yBAAyB;IACzB,+BAA+B;IAC/B,UAAU;IACV,SAAS;EACX;;EAEA;IACE,uBAAuB;IACvB,+BAA+B;IAC/B,iBAAiB;IACjB,YAAY;IACZ,SAAS;EACX;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,OAAO;IACP,WAAW;IACX,4CAA4C;IAC5C,2BAA2B;IAC3B,wBAAwB;EAC1B;EACA;IACE,yBAAyB;IACzB,+BAA+B;IAC/B,UAAU;IACV,SAAS;EACX;;EAEA;IACE,uBAAuB;IACvB,+BAA+B;IAC/B,YAAY;IACZ,SAAS;EACX;AACF","sourcesContent":[".adminwrapper {\n  margin: 0;\n  background-color: var(--white-color);\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  overflow: hidden;\n  padding: 0px;\n  position: relative;\n}\n\n.sidebarBack {\n  position: absolute;\n  /* top: 4%; */\n  /* right: -7%; */\n  z-index: 1;\n  transform: translateY(-50%);\n  border: none;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: var(--white-color);\n  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n  cursor: pointer;\n  color: var(--subheading);\n  display: none;\n  align-items: center;\n  justify-content: center;\n}\n\n@media (max-width: 768px) {\n  .sidebarBack {\n    /* right: 25px; */\n    box-shadow: rgba(255, 255, 255, 0.608) 0px 7px 29px 0px;\n    display: flex;\n  }\n  .rootMainContant.hidden {\n    display: none;\n  }\n  /* .admin-sidebar ul {\n    display: none;\n  } */\n  .rotateOpen {\n    transform: rotate(180deg);\n    transition: transform 0.3s ease;\n    right: 2px;\n    top: 10px;\n  }\n\n  .rotateClosed {\n    transform: rotate(0deg);\n    transition: transform 0.3s ease;\n    /* right: -5px; */\n    right: -15px;\n    top: 10px;\n  }\n}\n\n@media (max-width: 368px) {\n  .sidebarBack {\n    width: 40px;\n    height: 40px;\n    font-size: 22px;\n    top: 1%;\n    right: 15px;\n    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n    transform: translateX(16px);\n    transform-origin: center;\n  }\n  .rotateOpen {\n    transform: rotate(180deg);\n    transition: transform 0.3s ease;\n    right: 2px;\n    top: 10px;\n  }\n\n  .rotateClosed {\n    transform: rotate(0deg);\n    transition: transform 0.3s ease;\n    right: -15px;\n    top: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"adminwrapper": `RootStyle_adminwrapper__r--KX`,
	"sidebarBack": `RootStyle_sidebarBack__z4teo`,
	"rootMainContant": `RootStyle_rootMainContant__XgKRy`,
	"hidden": `RootStyle_hidden__+01+E`,
	"rotateOpen": `RootStyle_rotateOpen__JIljI`,
	"rotateClosed": `RootStyle_rotateClosed__kouXK`
};
export default ___CSS_LOADER_EXPORT___;
